import { useQuery } from '@tanstack/react-query';
import type { ViewDateSourceDTO } from '@tempo-io/roadmap-dto';
import { useCallback } from 'react';
import { ONE_HOUR_IN_MS } from '@/common/constants';
import { useFlag } from '@/common/hooks/feature-flags/useFlag';
import { viewQueryKeys } from '@/features/views/queryKeys';
import { DateSourceApi } from '@/features/visualizations/api/dateSource';
import { resolveEffectiveDateSource } from '@/features/visualizations/utils/itemDateSource';

const PLAN_DATE_SOURCE = (viewId: number): ViewDateSourceDTO => ({
  viewId,
  dateSourceType: 'PLAN',
  startCustomFieldId: null,
  finishCustomFieldId: null,
});

export const useViewDateSource = (viewId: number, options?: { enabled?: boolean }) => {
  const plannerModuleEnabled = useFlag('plannerModuleEnabled');

  const select = useCallback(
    (dateSource: ViewDateSourceDTO) => resolveEffectiveDateSource(dateSource, plannerModuleEnabled),
    [plannerModuleEnabled],
  );

  return useQuery({
    queryKey: viewQueryKeys.dateSource.detail(viewId),
    queryFn: () => DateSourceApi.fetchDateSource(viewId),
    staleTime: ONE_HOUR_IN_MS,
    placeholderData: PLAN_DATE_SOURCE(viewId),
    enabled: options?.enabled,
    select,
  });
};
